export default __webpack_public_path__ + "static/media/Group -9.f1f88369.svg";